module.exports = require('./first');



/*****************
 ** WEBPACK FOOTER
 ** /Users/spikelny/Desktop/projects/art/fastcash/~/lodash/array/head.js
 ** module id = 442
 ** module chunks = 0
 **/